export const CONNECTION_ZELLE = 1;
export const CONNECTION_VENMO = 2;
export const CONNECTION_PAYPAL = 3;
export const CONNECTION_STRIPE = 4;
export const CONNECTION_TITLES = {
	[CONNECTION_ZELLE]: 'Zelle',
	[CONNECTION_VENMO]: 'Venmo',
	[CONNECTION_PAYPAL]: 'PayPal',
	[CONNECTION_STRIPE]: 'Stripe'
};
export const CONNECTION_STATUS_CONFIRMED = 1;
export const CONNECTION_STATUS_PENDING = 2;

export const CONNECTION_ICNOS = {
	[CONNECTION_ZELLE]: require("@/assets/images/brands/zelle.png"),
	[CONNECTION_VENMO]: require("@/assets/images/brands/venmo.png"),
	[CONNECTION_PAYPAL]: require("@/assets/images/brands/paypal.png"),
	[CONNECTION_STRIPE]: require("@/assets/images/brands/stripe.png"),
};